export const userMatchesSearchTerm = (user, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === "") {
    return true;
  }

  const normalizedSearch = searchTerm.toLowerCase();

  return (
    user?.email?.toLowerCase().includes(normalizedSearch) ||
    user?.firstName?.toLowerCase().includes(normalizedSearch) ||
    user?.lastName?.toLowerCase().includes(normalizedSearch) ||
    user?.tenantName?.toLowerCase().includes(normalizedSearch)
  );
};

export const userMatchesTenantFilter = (user, tenantId) => {
  if (!tenantId) {
    return true;
  }

  return user.tenantId === tenantId;
};

export const userMatchesFilters = (user, { searchTerm = "", tenantId = null } = {}) => {
  return userMatchesSearchTerm(user, searchTerm) && userMatchesTenantFilter(user, tenantId);
};

export const filterUsersList = (users, { searchTerm = "", tenantId = null } = {}) => {
  if (!users) {
    return users;
  }

  return users.filter((user) => userMatchesFilters(user, { searchTerm, tenantId }));
};

export const appendUserToLists = (usersData, filteredUsers, newUser, { searchTerm = "", tenantId = null } = {}) => {
  if (usersData.some((user) => user.email === newUser.email)) {
    return { usersData, filteredUsers };
  }

  const updatedUsersData = [...usersData, newUser];
  const hasFilters = filteredUsers.length !== usersData.length;
  const matchesFilters = userMatchesFilters(newUser, { searchTerm, tenantId });

  if (!hasFilters || matchesFilters) {
    return {
      usersData: updatedUsersData,
      filteredUsers: [...filteredUsers, newUser]
    };
  }

  return {
    usersData: updatedUsersData,
    filteredUsers
  };
};
